import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
// import { useCart } from "../../contexts/CartContext";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  // const { openCart, items } = useCart();

  const isOnLayoutPage = location.pathname.startsWith("/Layout");

  const handleCartOpen = () => {
    console.log("Cart icon clicked");
    // openCart();
    setIsMenuOpen(false); // Optional: close mobile menu if open
  };

  return (
    <header className="bg-white shadow-md py-4 mb-10 sticky top-0 z-50 h-auto  ">
      <div className="mx-auto flex items-center justify-between px-4 md:px-8">
        {/* Logo */}
        <div className="text-2xl font-bold text-orange-500">
          <Link to="/" aria-label="Home">
          <img
  className="h-10"
  src="/assets/Images/logoimg.png"
  alt="Company Logo"
/>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <Link to="/" className="text-gray-700 hover:text-orange-500">
            Home
          </Link>
          <Link to="/contact" className="text-gray-700 hover:text-orange-500">
            Contact
          </Link>
          <Link to="/gallery" className="text-gray-700 hover:text-orange-500">
            Gallery
          </Link>
         
        </nav>

        {/* Mobile Hamburger */}
        <div className="md:hidden w-1/2 flex items-center justify-end">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-orange-500"
            aria-label="Toggle Navigation Menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 5.25h16.5m-16.5 6h16.5m-16.5 6h16.5"
              />
            </svg>
          </button>
        </div>

        {/* Right-Side Button (Cart or Style) */}
        <div>
          {!isOnLayoutPage ? (
            <Link
              to="/Catalog"
              className="hidden md:block bg-[#30465a] text-white px-4 py-2 rounded hover:bg-[#243a4a]"
            >
              Select Your Style
            </Link>
          ) : (
            <button
              onClick={handleCartOpen}
              className="hidden md:flex items-center gap-2 border border-orange-500 text-orange-500 px-3 py-2 rounded hover:bg-orange-50"
            >
              <FiShoppingCart size={20} />
              <span className="hidden lg:inline">Cart</span>
            </button>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <nav className="md:hidden bg-white shadow-md mt-6 px-4 py-2 space-y-4 rounded-md">
          <Link
            to="/"
            className="block text-gray-700 hover:text-orange-500"
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/contact"
            className="block text-gray-700 hover:text-orange-500"
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>
          <Link
            to="/gallery"
            className="block text-gray-700 hover:text-orange-500"
            onClick={() => setIsMenuOpen(false)}
          >
            Gallery
          </Link>

          {!isOnLayoutPage ? (
            <Link
              to="/catalog"
              className="block bg-[#30465a] text-white px-4 py-2 rounded hover:bg-[#243a4a] text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Select Your Style
            </Link>
          ) : (
            <button
              onClick={handleCartOpen}
              className="w-full flex justify-center items-center gap-2 bg-[#30465a] text-white px-4 py-2 rounded hover:bg-[#243a4a] text-center"
            >
              <FiShoppingCart size={20} />
              <span>Cart</span>
            </button>
          )}
        </nav>
      )}
    </header>
  );
};

export default Header;
